import { lazy, Suspense, type ReactNode } from 'react';

export const SpectatorRoute = lazy(() =>
  import('./pages/SpectatorPage').then((module) => ({ default: module.SpectatorPage })),
);
export const TownRoute = lazy(() =>
  import('./pages/TownPage').then((module) => ({ default: module.TownPage })),
);
export const InventoryRoute = lazy(() =>
  import('./pages/InventoryPage').then((module) => ({ default: module.InventoryPage })),
);
export const DungeonsRoute = lazy(() =>
  import('./pages/DungeonsPage').then((module) => ({ default: module.DungeonsPage })),
);
export const SettingsRoute = lazy(() =>
  import('./pages/SettingsPage').then((module) => ({ default: module.SettingsPage })),
);
export const NotFoundRoute = lazy(() =>
  import('./pages/NotFoundPage').then((module) => ({ default: module.NotFoundPage })),
);
// OAuth callback leg (P6-5). Registered unconditionally; in offline builds it
// just renders the missing-parameters error.
export const AuthCallbackRoute = lazy(() =>
  import('./pages/AuthCallbackPage').then((module) => ({ default: module.AuthCallbackPage })),
);
// Dev-only persona monitor (ADR 0038 §2.5). The page itself runtime-guards on
// `import.meta.env.DEV`; the route is registered unconditionally so the lazy
// chunk is only fetched when visited.
export const MonitorRoute = lazy(() =>
  import('./pages/MonitorPage').then((module) => ({ default: module.MonitorPage })),
);

export function RouteSuspense({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<p role="status">Loading route...</p>}>{children}</Suspense>
  );
}
